import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.css']
})
export class TermsConditionComponent implements OnInit {

  constructor(private _route: Router) { }

  ngOnInit() {
  }
  gotoLogin() {
    this._route.navigate(['/login']);
  }
}
